<template>
  <div class="material">
    <div class="layout-content" style="background: transparent;">
      <Table :border="false" row-key="id" :columns="columns" :data="type" :load-data="handleLoadData" :loading="loading">
        <template slot-scope="{ row, index }" slot="name">{{ row.name }}</template>
        <template slot-scope="{ row, index }" slot="nameEn">{{ row.nameEn }}</template>
        <template slot-scope="{ row, index }" slot="showIndex">{{ row.showIndex }}</template>
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
            <span style="display: inline-block;padding: 0 5px;">|</span>
            <span style="color: #1890ff;cursor: pointer;" @click="editSubShow(row)"
              v-if="row.type === 1 || row.type === 2 || row.type === 3">添加子项</span>
            <span style="display: inline-block;padding: 0 5px;"
              v-if="row.type === 1 || row.type === 2 || row.type === 3">|</span>
            <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
              <span style="color: #f00;cursor: pointer;">删除</span>
            </Poptip>
          </div>
        </template>
      </Table>
    </div>
    <!-- 修改展商置顶 -->

    <proClassifyAdd :show="classify" @finish="reload()" @close="classify = false;" />
    <proClassifyEdit :show="editClassify" v-if="editClassify" @finish="reload()" :editInfo="editClassifyInfo"
      @close="editClassify = false; editClassifyInfo = null;" />
    <proClassifySubAdd :show="editclassifySub" :info="editclassifySubInfo" @finish="reload()"
      @close="editclassifySub = false; editclassifySubInfo = null;" />
  </div>
</template>


<script>
import proClassifyAdd from "./components/pro-classify-add.vue";
import proClassifySubAdd from "./components/pro-classify-sub-add";
import proClassifyEdit from "./components/pro-classify-edit.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "host-set-pro-category",
  data () {
    return {
      columns: [
        {
          title: "展品类别",
          key: "name",
          tree: true,
        },
        {
          title: "英文展品类别",
          key: "nameEn",
        },
        {
          title: "排序",
          key: "showIndex",
          width: "100px"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      loading: false,
      classify: false,
      editClassify: false,
      editClassifyInfo: null,
      editclassifySub: false,
      editclassifySubInfo: null,
      type: [],
      parent1: null,
      showRecord: [], // 记录表格点开的行
    };
  },
  components: {
    proClassifyAdd,
    proClassifyEdit,
    proClassifySubAdd
  },
  computed: {
    ...mapGetters({
      hostExhibition: "hostSetModule/getHostExhibition",
    }),
    option () {
      return {
        ExhibitionId: this.hostExhibition.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      };
    }
  },
  watch: {
    type: {
      handler: function (val) {
        val.map(c => {
          // 添加
          if (c._showChildren && this.showRecord.indexOf(c.id) === -1) {
            this.showRecord.push(c.id);
          }
          if (c.children && c.children.length > 0) {
            c.children.map(d => {
              if (d._showChildren && this.showRecord.indexOf(d.id) === -1) {
                this.showRecord.push(d.id);
              }

              if (d.children && d.children.length > 0) {
                d.children.map(v => {
                  if (v._showChildren && this.showRecord.indexOf(v.id) === -1) {
                    this.showRecord.push(v.id);
                  }
                })
              }
            })
          }
          // 移除
          if (!c._showChildren && this.showRecord.indexOf(c.id) !== -1) {
            let num = this.showRecord.indexOf(c.id);
            this.showRecord.splice(num, 1);
          }
          if (c.children && c.children.length > 0) {
            c.children.map(d => {
              if (!d._showChildren && this.showRecord.indexOf(d.id) !== -1) {
                let num2 = this.showRecord.indexOf(d.id);
                this.showRecord.splice(num2, 1);
              }
            })
          }
        })
      },
      deep: true
    }
  },
  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      getProductByGroupId: "categoryModule/getProductByGroupId",
      delCategory: "categoryModule/delCategory",
      addCategory: "categoryModule/addCategory"
    }),
    async init () {
      this.loading = true;
      setTimeout(() => { this.loading = false }, 5000);
      let opt = {
        groupId: this.hostExhibition.groupId,
        level: -1,
        loadChild: true,
      }
      let categoryData = await this.getProductByGroupId(opt);
      this.loading = false;
      if (categoryData && categoryData.length) {
        categoryData.map((c, index) => { 
          c.type = 1;
          c.num = c.list.length;
          if (c.num) {
            c.children = [];
            c._loading = false;
            c._showChildren = false;
          }
          // 若存在，展开对应的行
          if (this.showRecord && this.showRecord.indexOf(c.id) !== -1) {
            c.children = c.list;
            c._showChildren = true;
          } else {
            c._showChildren = false;
          }
          if (c.children && c.children.length > 0) {
            c.children.map(d => {
              d.type = 2;
              d.children = d.list;
              // 若存在，展开对应的行
              if (this.showRecord && this.showRecord.indexOf(d.id) !== -1) {
                d._showChildren = true;
              } else {
                d._showChildren = false;
              }
              if (d.children && d.children.length > 0) {
                d.children.map(v => {
                  v.type = 3;
                  v.children = v.list;
                  // 若存在，展开对应的行
                  if (this.showRecord && this.showRecord.indexOf(v.id) !== -1) {
                    v._showChildren = true;
                  } else {
                    v._showChildren = false;
                  }
                })
              }
            })
          }
        }); 
        this.type = categoryData;
      } else {
        this.type = [];
      }
    },
    changePage (e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize (e) {
      this.pageSize = e;
      this.init();
    },
    setClassify (item) {
      // 设置置顶
      this.classifyInfo = item;
      this.classify = true;
    },
    setClassifyEdit (item) {
      // 设置品牌
      this.editClassifyInfo = item;
      this.editClassify = true;
    },
    searchPro () {
      this.pageIndex = 1;
      this.init();
    },
    async delItem (item) {
      let result = await this.delCategory(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.reload();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },

    handleLoadData (item, callback) {
      const list = JSON.parse(JSON.stringify(item.list));
      console.log('list', list);
      list._showChildren = true;
      list.map(c => {
        c.type = item.type + 1;
        c.num = c.list.length;
        if (c.num) {
          c.children = [];
          c._loading = false;
        }
      });
      callback(list);
      console.log(' this.type', this.type[0].list[0]);
    },
    editShow (e) {
      this.editClassify = true;
      this.editClassifyInfo = e;
    },
    editSubShow (e) {
      console.log('添加子项：', e);
      this.editclassifySub = true;
      this.editclassifySubInfo = e;
    },
    close () {
      this.classify = false;
      this.editClassify = false;
      this.editClassifyInfo = null;
    },
    showAdd () {
      this.classify = true;
    },
    reload () {
      this.loading = true;
      setTimeout(() => {
        this.init();
      }, 2000);
    }
  }
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;

  button {
    margin-right: 20px;
  }
}

.logo {
  width: 60px;
  height: 60px;
  display: inline-block;
}

.cate-item {
  width: 200px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; // 显示的行数
  overflow: hidden;
}

.layout-content {
  table {}
}
</style>

<style lang="scss">
.cate-item {
  width: 200px;

  &:hover {
    color: #1890ff;
  }
}

.cate-pop-item {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  margin-top: 6px;

  .cate-brand {
    display: inline-block;
    border: solid 1px #f0f0f0;
    background-color: #f5f5f5;
    padding: 0 6px;
    margin-right: 6px;
    margin-bottom: 6px;
    color: #333;

    :hover {
      color: #333;
    }

    &-close {
      font-size: 21px;
      position: relative;
      top: 1px;
    }
  }
}
</style>

